function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@isyc-react/design/overlays';
import { ViewerControlTooltip } from "../../../tooltip";
import { nsarchives } from "../../../../../../i18n/namespaces";
import clsx from 'clsx';
import { ViewerControlButton } from "../../button";
import { ZoomOption } from "../../../../base/page";
import "./control-zoom-overlay.style.scss";
const ZoomItem = props => {
  const {
    onClick,
    children,
    active
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "zoom-item",
    onClick: () => onClick && onClick()
  }, /*#__PURE__*/React.createElement("div", {
    className: "tick"
  }, active && /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-check text-primary"
  })), /*#__PURE__*/React.createElement("div", null, children));
};
export const ViewerControlZoomOverlay = props => {
  const {
    disabled,
    onChange,
    zoom
  } = props;
  const [show, setShow] = React.useState(false);
  const {
    t
  } = useTranslation(nsarchives.common);
  // const { view } = useArchiveViewerContext()

  return /*#__PURE__*/React.createElement(Dropdown, {
    alignEnd: false,
    show: show,
    onToggle: nextShow => setShow(nextShow),
    drop: 'down'
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, null, (toggleProps, meta) => /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.zoom'),
    show: show ? false : undefined
  }, /*#__PURE__*/React.createElement(ViewerControlButton, _extends({
    disabled: disabled
  }, toggleProps, {
    onClick: () => meta.toggle(!show),
    className: clsx({
      'control-zoom-active': show
    })
  }), /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-magnify-plus-outline"
  })))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    flip: false,
    offset: [0, 0]
  }, (menuProps, meta) => /*#__PURE__*/React.createElement("div", _extends({}, menuProps, {
    className: "control-zoom-overlay"
  }), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_WINDOW_SIZE,
    onClick: () => onChange && onChange(ZoomOption.Z_WINDOW_SIZE)
  }, t('archive.view.controls.zoomWindowSize')), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_WINDOW_WIDTH,
    onClick: () => onChange && onChange(ZoomOption.Z_WINDOW_WIDTH)
  }, t('archive.view.controls.zoomWindowWidth')), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_50,
    onClick: () => onChange && onChange(ZoomOption.Z_50)
  }, "50%"), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_75,
    onClick: () => onChange && onChange(ZoomOption.Z_75)
  }, "75%"), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_100,
    onClick: () => onChange && onChange(ZoomOption.Z_100)
  }, "100%"), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_125,
    onClick: () => onChange && onChange(ZoomOption.Z_125)
  }, "125%"), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_150,
    onClick: () => onChange && onChange(ZoomOption.Z_150)
  }, "150%"), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_200,
    onClick: () => onChange && onChange(ZoomOption.Z_200)
  }, "200%"), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_300,
    onClick: () => onChange && onChange(ZoomOption.Z_300)
  }, "300%"), /*#__PURE__*/React.createElement(ZoomItem, {
    active: zoom === ZoomOption.Z_400,
    onClick: () => onChange && onChange(ZoomOption.Z_400)
  }, "400%"))));
};